import { FieldState } from '@angular/forms/signals';

/**
 * Commits an `app-dropdown` selection into a Signal Forms field.
 *
 * `DropdownComponent` is a ControlValueAccessor, which Signal Forms' `[formField]`
 * does not consume, so every dropdown is bound manually: `[dropdownOption]` in,
 * `(valueChange)` out. Writing the value signal is only half of that write —
 * `value.set()` is a programmatic update, so it does NOT mark the field dirty.
 * A form whose only edit was a dropdown therefore stayed pristine, leaving the
 * Save button disabled and the unsaved-changes guard unarmed (SEOMS-480).
 *
 * Both halves live here so a caller cannot apply one and forget the other —
 * which is exactly how nine handlers ended up committing without dirtying.
 *
 * @param field The field state to write, e.g. `f.installCrew()`.
 * @param value The already-coerced value; the caller narrows the dropdown's
 *   `string | boolean` output to the field's own type.
 */
export function commitDropdownValue<TValue>(
  field: FieldState<TValue>,
  value: TValue,
): void {
  field.value.set(value);
  field.markAsDirty();
}
